<template>
  <transition name="slide-up-down">
    <div
      v-if="show && !alertDismissed"
      class="friskkollen-success-footer pt-5 pb-2"
    >
      <!-- button to close the footer alert -->
      <div class="close-wrapper-alert-button">
        <button variant="link" class="btn p-0" @click="dismissAlert">
          <i class="bi bi-x fs-1 p-0"></i>
        </button>
      </div>
      <div
        class="d-flex align-items-center justify-content-center ps-4 pe-4 pb-4 mb-4"
      >
        <i class="bi bi-check-circle-fill fs-3 text-success me-3"></i>
        <span class="fs-2">
          {{ $tr(data.locales, 'steps.done.message') }}
        </span>
      </div>
      <div class="d-flex align-items-center justify-content-center px-4">
        <p class="fs-3">
          {{ $tr(data.locales, 'steps.done.appPromo') }}
          <a
            :href="$tr(data.locales, 'steps.done.link.feelgoodApp.url')"
            class="text-decoration-underline"
            target="_blank"
          >
            {{ $tr(data.locales, 'steps.done.link.feelgoodApp.title') }} </a
          >.
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UserConfirmedActions',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      alertDismissed: false
    }
  },
  methods: {
    dismissAlert() {
      this.alertDismissed = true
    }
  }
}
</script>
